<template>
  <v-card flat>
    <h2 v-if="title">{{ title }}</h2>

    <v-form ref="form" :lazy-validation="true">
      <v-menu
        ref="pickermenu"
        v-model="pickermenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{on}">          
          <v-text-field
            :class="`${addClass}`"
            outlined
            v-model="cmpValue"
            :placeholder="placeholder"
            :disabled="isDisabled"
            :append-icon="icon"
            v-on="on"
            :label="label"
            :hint="hint"
            :persistent-hint="persistentHint"
            :clearable="clearable"
            :rules="required ? [rules.required] : []"
            @blur="cmpValue = pickerValue = $options.filters.date(Date.parse(cmpValue))"
            @click:clear="$nextTick(() => (cmpValue = pickerValue = null))"
            @click:append="pickermenu=true"
          />
        </template>
        <v-date-picker
          :min="miniumDate"
          :max="maximumDate"
          v-model="pickerValue"
          no-title
          @input="pickermenu = false"
          :first-day-of-week="1"
          :locale="locale"
        />
      </v-menu>
    </v-form>
  </v-card>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
import {mapActions, mapGetters} from 'vuex'

// @group Common
// Styled DatePicker component
export default {
  name: 'DatePicker',

  mixins: [RulesMixin],

  props: {
    hint: {
      type: String,
      default: ''
    },

    // Keep hint visible even when input is not focused
     persistentHint: {
       type: Boolean,
       default: false
     },
    //date from v-modeö
    value: {
      // `'String'`
      type: String
    },
    miniumDate: {
      type: String,
      default: ''
    },
    maximumDate: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    // Has label
    label: {
      // `'String'`
      type: String,
      // The default value is: `function returning label`
      default: function () {
        return this.$t('fields.start-date')
      }
    },
    //has outlined
    outlined: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    //it's clearable
    clearable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    //has title
    title: {
      // `String`
      type: String,
      // The default value is: `''`
      default: ''
    },
    //has addclass
    addClass: {
      // `String`
      type: String,
      // The default value is: `''`
      default: ''
    },
    //has placeholder
    placeholder: {
      // `String`
      type: String,
      // The default value is: `function returning placeholder`
      default: function () {
        return this.$t('placeholders.date')
      }
    },
    //is required
    required: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    }
  },

  data() {
    return {
      //- Pickermenu flag
      pickermenu: false,
      //- Our private copy of value
      cmpValue: null,
      pickerValue: null
    }
  },

  computed: {
    ...mapGetters('app', ['locale'])
  },

  created() {
    //- Handle start value
    this.cmpValue = this.pickerValue = this.$options.filters.date(Date.parse(this.value))
  },

  watch: {
    value(val) {
      //- Make sure we have correct value if it changes i parent
      this.cmpValue = this.isValidDate(val) ? this.$options.filters.date(val) : val
      this.pickerValue = this.isValidDate(val) ? this.$options.filters.date(val) : null
    },
    /**
     * @vuese
     * Used to watch cmpValue and emit new input
     * @arg the argument is a new  date  selected
     */
    cmpValue(val) {
      //- Tell parent we've changed the value
      this.$emit('input', val === '' ? null : val)
    },
    pickerValue(val) {
      this.cmpValue = val ? val : this.cmpValue
    }
  },

  methods: {
    isValidDate(date) {
      let d = new Date(date)
      return (
        !(Object.prototype.toString.call(d) !== '[object Date]' || isNaN(d.getTime())) &&
        Boolean(date && date.match(/^(\d{4})-(\d{2})-(\d{2})/))
      )
    }
  }
}
</script>

<style scoped>
</style>